import * as d3 from "d3";

//WRAP THE TEXT UPTO FOUR LINE AND ADD DEFAULT TOOLTIP
export function wrapText(
  text,
  width,
  numOfLine,
  breakFromWord,
  xPadding = 0,
  nameLookup,
) {
  if (!text) return;
  const textSplitType = breakFromWord ? " " : "";
  text.each(function () {
    const text = d3.select(this);
    const fullText = nameLookup ? nameLookup[text.text()] : text.text();
    const words = fullText?.split(textSplitType).reverse();
    // const words = fullText.split(/\s+/).reverse();
    let word;
    let line = [];
    let lineNumber = 0;
    const lineHeight = 1.1; // ems
    const maxLines = numOfLine; // Maximum number of lines
    const y = text.attr("y");
    const dy = parseFloat(text.attr("dy"));
    let tspan = text
      .text(null)
      .append("tspan")
      .attr("x", xPadding)
      .attr("y", y)
      .attr("dy", dy + "em");

    let isClipped = false; // Flag to check if text is clipped

    while ((word = words.pop())) {
      line.push(word);
      tspan.text(line.join(textSplitType));
      // tspan.text(line.join(" "));

      if (tspan.node().getComputedTextLength() > width) {
        line.pop(); // Remove the last word that caused overflow
        tspan.text(line.join(textSplitType));
        // tspan.text(line.join(" "));

        if (lineNumber + 1 >= maxLines) {
          // If it's the last allowed line, add "..." and break the loop
          tspan.text(line.join(textSplitType) + "...");
          // tspan.text(line.join(" ") + "...");
          isClipped = true; // Mark text as clipped
          break;
        }

        // Start a new line
        line = [word];
        tspan = text
          .append("tspan")
          .attr("x", xPadding)
          .attr("y", y)
          .attr("dy", ++lineNumber * lineHeight + dy + "em")
          .text(word);
      }
    }

    // Add a <title> element
    text.append("title").text(fullText);
  });
}

export function getContrastColor(hex) {
  // Remove #
  const color = hex.replace("#", "");

  // Convert to RGB
  const r = parseInt(color.substring(0, 2), 16);
  const g = parseInt(color.substring(2, 4), 16);
  const b = parseInt(color.substring(4, 6), 16);

  // Calculate luminance
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

  // Return black or white
  return luminance > 150 ? "#000" : "#fff";
}
